import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Box, } from '@waglabs/box-next';
import { Flex } from '@waglabs/flex-next';
import { Input } from '@waglabs/input';
import { HelperText, } from './HelperText';
const applyErrorStyleIfExists = (error) => {
    if (!error) {
        return;
    }
    return {
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'red',
    };
};
// TODO Create a styled-system for this
const StyledInput = styled(Input) `
  outline: none;

  ::placeholder {
    color: #aaaaaa;
    /*
      Chrome don't have padding by default
      Safari mobile includes padding by default
    */
    padding: 0; 
  }
`;
const Base = forwardRef(({ label, value, fullWidth, inputProps: { startAdornment: StartAdornmentComponent, endAdornment: EndAdornmentComponent, ...restInputProps } = {
    startAdornment: null,
    endAdornment: null,
}, containerProps, ...rest }, ref) => (React.createElement(Flex, Object.assign({ borderWidth: "1px", borderStyle: "solid", borderColor: "lightGrey" }, containerProps, { display: fullWidth ? 'flex' : 'inline-flex', borderRadius: "8px", p: 2 }),
    StartAdornmentComponent && (React.createElement(Flex, { pr: "8px" },
        React.createElement(StartAdornmentComponent, null))),
    React.createElement(StyledInput, Object.assign({ flex: 1, fontFamily: "muli", fontSize: 4, value: value, color: "medGray", p: 0 }, restInputProps, { border: "none" }, rest, { ref: ref, placeholder: label })),
    EndAdornmentComponent && (React.createElement(Flex, { pl: "8px" },
        React.createElement(EndAdornmentComponent, null))))));
const variantMapping = {
    filled: forwardRef(({ containerProps, error, inputProps, ...rest }, ref) => (React.createElement(Base, Object.assign({ containerProps: {
            borderStyle: 'none',
            ...applyErrorStyleIfExists(error),
            backgroundColor: 'backgroundGray',
            ...containerProps,
        }, inputProps: {
            backgroundColor: 'backgroundGray',
            ...inputProps,
        }, ref: ref }, rest)))),
    outlined: forwardRef((props, ref) => (React.createElement(Base, Object.assign({ ref: ref, containerProps: {
            ...applyErrorStyleIfExists(props.error),
            ...props.containerProps,
        } }, props)))),
};
export const TextField = forwardRef(({ variant = 'outlined', helperText, helperTextProps, ...rest }, ref) => {
    const Component = variantMapping[variant];
    return (React.createElement(Box, null,
        React.createElement(Component, Object.assign({ ref: ref }, rest)),
        React.createElement(HelperText, Object.assign({ text: helperText, error: rest.error }, helperTextProps))));
});
